// Should be imported only by analytics.js to prevent importing multiple modules
export const _EVENT_NAMES = {
  ADD_CENTERPIECE_TAPPED: 'Add Centerpiece Tapped',
  ADD_ART_TAPPED: 'Add Art Tapped',
  ADD_PHOTOS_TAPPED: 'Add Photos Tapped',
  ADD_PET_PORTRAITS_TAPPED: 'Add Pet Portraits Tapped',
  ADD_FAMILY_PORTRAITS_TAPPED: 'Add Family Portraits Tapped',
  ADD_PHOTOS_TO_COLLAGE_POPUP_OPENED: 'add Photos To Collage Popup Opened',
  ADD_PROMO_CODE_TAPPED: 'Add Promo Code Tapped',
  ADJUST_PHOTO_TAPPED: 'Adjust Photo Tapped',
  ART_PICKER_ARTWORK_ADDED: 'Art Picker: Artwork Added',
  ART_PICKER_ARTWORK_SELECTED: 'Art Picker: Artwork Selected',
  ART_PICKER_ARTWORK_UNSELECTED: 'Art Picker: Artwork Unselected',
  ART_PICKER_CATEGORY_TAPPED: 'Art Picker: Category Tapped',
  ART_PICKER_NEXT_TAPPED: 'Art Picker: Next Tapped',
  ART_PICKER_OPENED: 'Art Picker Opened',
  BLOG_ARTICLE_TAPPED: 'Blog: Article Tapped',
  BLOG_ARTICLE_BREADCRUMBS_TAPPED: 'Blog: Article Breadcrumbs Tapped',
  BLOG_PAGINATION_TAPPED: 'Blog: Pagination Tapped',
  BLOG_POPULAR_ARTICLE_TAPPED: 'Blog: Popular Article Tapped',
  BLOG_TAG_TAPPED: 'Blog: Tag Tapped',
  BOOK_INTRO_HOMEPAGE_FAQ_VIEWED:
    'Book Intro: Frequently Asked Questions Viewed',
  BOOK_INTRO_HOMEPAGE_FAQ_TAPPED: 'Book Intro: FAQ - Question Tapped',
  BOOKS_BOOK_CREATED: 'Books: Book Created',
  BOOKS_PAGES_BUTTON_TAPPED: 'Books: Pages Button Tapped',
  BOOKS_ORDER_PAGES_CLOSED: 'Books: Order Pages: Closed',
  BOOKS_ORDER_PAGES_DONE: 'Books: Order Pages: Done Tapped',
  BOOKS_ORDER_PAGES_PAGE_TAPPED: 'Books: Order Pages: Page Tapped',
  BOOKS_ORDER_PAGES_SORT_TAPPED: 'Books: Order Pages: Sort Tapped',
  BOOKS_COVER_BUTTON_TAPPED: 'Books: Cover Button Tapped',
  BOOKS_COVER_EDIT_DONE_TAPPED: 'Books: Cover Edit: Done Tapped',
  BOOKS_COVER_EDIT_PHOTO_TAPPED: 'Books: Cover Edit: Photo Tapped',
  BOOKS_COVER_EDIT_ADD_PHOTO_TAPPED: 'Books: Cover Edit: Add Photo Tapped',
  BOOKS_COVER_EDIT_PHOTO_ADDED: 'Books: Cover Edit: Photo Added',
  BOOKS_COVER_EDIT_TITLE_EDIT_STARTED: 'Books: Cover Edit: Title Edit Started',
  BOOKS_COVER_EDIT_TITLE_REMOVED: 'Books: Cover Edit: Title Removed',
  BOOKS_COVER_TITLE_TAPPED: 'Books: Cover Title Tapped',
  BOOKS_COVER_EDIT_TOGGLE_TAPPED: 'Books: Cover Edit: Toggle Tapped',
  BOOKS_COVER_USE_THIS_COVER_TAPPED: 'Books: Cover Use This Cover Tapped',
  BOOKS_COVER_EDIT_TEXT_LIMIT_REACHED: 'Books: Cover Edit: Text Limit Reached',
  BOOKS_ADD_CAPTION_TAPPED: 'Books: Add Caption Tapped',
  BOOKS_PAGE_CAPTION_EDIT_DONE: 'Books: Page Captions: Edit Done',
  BOOKS_PAGE_CAPTION_LIMIT_REACHED: 'Books: Page Captions: Limit Reached',
  BOOKS_DELETE_PAGE_TAPPED: 'Books: Delete Page Tapped',
  BOOKS_EDITOR_FRAME_TIME_SAMPLED: 'Books: Editor Frame Time Sampled',
  BOOKS_EXCEEDING_PHOTOS_DONE_TAPPED: 'Books: Exceeding Photos: Done Tapped',
  BOOKS_EXTERNAL_BOOK_RECEIVED: 'Books: External Book Received',
  BOOKS_EXTERNAL_PHOTOS_RECEIVED: 'Books: External Photos Received',
  BOOKS_EXTERNAL_PHOTOS_REJECTED: 'Books: External Photos Rejected',
  BOOKS_FEEDBACK_SUBMITTED: 'Books: Feedback Submitted',
  BOOKS_HOME_PAGE_CTA_TAPPED: 'Books: Homepage CTA Tapped',
  BOOKS_HOW_TO_ARRANGE_TAPPED: 'Books: How To Arrange Tapped',
  BOOKS_LOW_RES_IMAGE_REMOVED: 'Books: Low Res Image Removed',
  BOOKS_LOW_RES_POPUP_APPROVED: 'Books: Low Res Popup Approved',
  BOOKS_LOW_RES_WARNING_DISPLAYED: 'Books: Low Res Warning Displayed',
  BOOKS_LOW_RES_WARNING_TAPPED: 'Books: Low Res Warning Tapped',
  BOOKS_NOT_ENOUGH_PHOTOS_WARNING_DISPLAYED:
    'Books: Not Enough Photos Warning Displayed',
  BOOKS_NOT_ENOUGH_PHOTOS_WARNING_TAPPED:
    'Books: Not Enough Photos Warning Tapped',
  BOOKS_WARNING_DISMISSED: 'Books: Warning Dismissed',
  BOOKS_MINIMUM_PAGES_REACHED: 'Books: Minimum Pages Reached',
  BOOKS_PAGE_LIMIT_REACHED: 'Books: Page Limit Reached',
  BOOKS_PAGE_MOVED: 'Books: Page Moved',
  BOOKS_PAGE_SWIPED: 'Books: Page Swiped',
  BOOKS_PAGE_TAPPED: 'Books: Page Tapped',
  BOOKS_PHOTO_CROPPED: 'Books: Photo Cropped',
  BOOKS_PHOTOS_SORT_ORDER_SELECTED: 'Books: Photos Sort Order Selected',
  BOOKS_SIZE_DRAWER_TAPPED: 'Books: Size Drawer Tapped',
  BOOKS_SIZE_DRAWER_SIZE_TAPPED: 'Books: Size Drawer Size Tapped',
  BOOKS_SIZE_DRAWER_DONE_TAPPED: 'Books: Size Drawer Done Tapped',
  BOOKS_USE_AS_COVER_TAPPED: 'Books: Use as Cover Tapped',
  BOOKS_COVER_FONT_SELECTED: 'Books: Cover Font Selected',
  BOOKS_DESIGNED_COVER_SELECTED: 'Books: Designed Cover Selected',
  BOOKS_DESIGNED_COVER_REMOVED: 'Books: Designed Cover Removed',
  BOOKS_CREATIVE_COVERS_TAPPED: 'Books: Creative Covers Tapped',
  BOOKS_COVER_TAB_SWITCHED: 'Books: Cover Tab Switched',
  BOOKS_AI_COVER_GENERATOR_OPENED: 'Books: AI Cover Generator Opened',
  BOOKS_AI_COVER_GENERATE_TAPPED: 'Books: AI Cover Generate Tapped',
  BOOKS_AI_COVER_GENERATED: 'Books: AI Cover Generated',
  BOOKS_AI_COVER_SELECTED: 'Books: AI Cover Selected',
  BOOKS_AI_COVER_GENERATION_FAILED: 'Books: AI Cover Generation Failed',
  BOOKS_AI_COVER_GENERATION_STARTED: 'Books: AI Cover Generation Started',
  BOOKS_AI_COVER_VIEWED: 'Books: AI Cover Viewed',
  BOOKS_AI_COVER_STYLE_SELECTED: 'Books: AI Cover Style Selected',
  BOOKS_AI_COVER_RESULT_SHOWN: 'Books: AI Cover Result Shown',
  BOOKS_AI_COVER_CHANGE_PHOTO_TAPPED: 'Books: AI Cover Change Photo Tapped',
  BOOKS_AI_COVER_IMAGE_SELECTED: 'Books: AI Cover Image Selected',
  BOOKS_COVER_DEEP_LINK_APPLIED: 'Books: Cover Deep Link Applied',
  BOOKS_COVER_DEEP_LINK_REJECTED: 'Books: Cover Deep Link Rejected',
  BOOKS_STORAGE_FELL_BACK_TO_LOCAL_STORAGE:
    'Books: Storage Fell Back To Local Storage',
  BOOKS_STORAGE_FULL: 'Books: Storage Full',
  BUSINESS_CONTACT_FORM_SUBMITTED: 'Business: Contact Form Submitted',
  BUSINESS_TAB_TAPPED: 'Business: Tab Tapped',
  CARD_DECLINED: 'Card Declined',
  CAREERS_LINK_CLICKED: 'Careers Link Clicked',
  CART_RESTORED: 'Cart Restored',
  CART_BAG_OPENED: 'Cart: Bag Opened',
  CART_EMPTY_SHOP_NOW_TAPPED: 'Cart: Empty Shop Now Tapped',
  CART_QUANTITY_CHANGED: 'Cart: Quantity Changed',
  CART_DISABLED_INCREMENT_TAPPED: 'Cart: Disabled Increment Tapped',
  CART_PRODUCT_DETAILS_EXPANDED: 'Cart: Product Details Expanded',
  CART_PRODUCT_EDIT_TAPPED: 'Cart: Product Edit Tapped',
  CART_REMOVE_ITEM_TAPPED: 'Cart: Remove Item Tapped',
  CART_REMOVE_ITEM_CONFIRMED: 'Cart: Remove Item Confirmed',
  CART_REMOVE_ITEM_CANCELLED: 'Cart: Remove Item Cancelled',
  CART_ADD_PRODUCT_TAPPED: 'Cart: Add Product Tapped',
  CART_PET_CANDIDATE_FOUND: 'Cart: Pet Candidate Found',
  CART_UPSELL_GENERATION_STARTED: 'Cart: Upsell Generation Started',
  CART_UPSELL_GENERATION_COMPLETED: 'Cart: Upsell Generation Completed',
  CART_UPSELL_GENERATION_FAILED: 'Cart: Upsell Generation Failed',
  CART_UPSELLS_AVAILABLE: 'Cart: Upsells Available',
  CART_UPSELL_CARD_SHOWN: 'Cart: Upsell Card Shown',
  CART_UPSELL_CARD_TAPPED: 'Cart: Upsell Card Tapped',
  CART_UPSELL_CARD_DISMISSED: 'Cart: Upsell Card Dismissed',
  CART_UPSELL_TILE_TOGGLED: 'Cart: Upsell Tile Toggled',
  CART_UPSELL_CAROUSEL_SWIPED: 'Cart: Upsell Carousel Swiped',
  CART_UPSELL_FLOW_DISMISSED: 'Cart: Upsell Flow Dismissed',
  CART_UPSELL_ADDED_TO_BAG: 'Cart: Upsell Added To Bag',
  CART_ARRIVES_BEFORE_HOLIDAY_SHOWN: 'Cart: Arrives Before Holiday Shown',
  GROUP_ORDER_COMPLETED: 'Group Order Completed',
  GROUP_ORDER_COMPLETE_REPORT_FAILED: 'Group Order Complete Report Failed',
  ORDER_COMPLETE_REPORT_FAILED: 'Order Complete Report Failed',
  CHANGE_PROMO_CODE_TAPPED: 'Change Promo Code Tapped',
  CHARGE_FAILED: 'Charge Failed',
  CHARGE_POST_PAYMENT_CANCELLED: 'Charge Post Payment Cancelled',
  CHECKOUT_ALREADY_USED: 'Checkout Already Used',
  INVALID_EMAIL_ORDER_ATTEMPTED: 'Invalid Email Order Attempted',
  CHECKOUT_CTA_LOADED: 'Checkout CTA Loaded',
  CHECKOUT_ITEM_COUNTER_TAPPED: 'Checkout: Item Counter Tapped',
  CHECKOUT_TAPPED: 'Checkout Tapped',
  ADD_TO_CART_TAPPED: 'Add To Cart Tapped',
  CHECKOUT_PRICING_ERROR_SHOWN: 'Checkout Pricing Error',
  CHECKOUT_PRICING_ERROR_REFRESH_CLICKED: 'Checkout Pricing Refresh Clicked',
  CHECKOUT_SHEET_OPENED: 'Checkout Sheet Opened',
  COMPLETE_ORDER_TAPPED: 'Complete Order Tapped',
  GIFT_CARD_ADD_EMAIL_TAPPED: 'Gift Card - Add Email Tapped',
  GIFT_CARD_CHANGE_TYPE_TAPPED: 'Gift Card - Change Type Tapped',
  GIFT_CARD_CUSTOM_VALUE_ENTERED: 'Gift Card - Custom Value Entered',
  GIFT_CARD_DESIGN_TAPPED: 'Gift Card - Design Tapped',
  GIFT_CARD_FIELD_ADDED: 'Gift Card - Field Added',
  GIFT_CARD_SCROLLED_TO_BOTTOM: 'Gift Card - Scrolled To Bottom',
  GIFT_CARD_VALUE_TAPPED: 'Gift Card - Value Tapped',
  CHECKOUT_SHIPPING_ADDRESS_ADDED: 'Checkout - Shipping Address Added',
  CHECKOUT_GIFT_CARD_EMAIL_ADDED: 'Checkout - Gift Card Email Added',
  CHECKOUT_GIFT_CARD_REMOVE_CANCELLED: 'Checkout - Gift Card Remove Cancelled',
  CHECKOUT_GIFT_CARD_REMOVE_CONFIRMED: 'Checkout - Gift Card Remove Confirmed',
  CHECKOUT_GIFT_CARD_REMOVE_TAPPED: 'Checkout - Gift Card Remove Tapped',
  CHECKOUT_MIXED_MATERIALS_TAPPED: 'Checkout - Mixed Materials Tapped',
  COLLAGE_CREATED: 'Collage Created',
  COLLAGE_ADD_PHOTOS_TAPPED: 'Collage Add Photos Tapped',
  COLLAGE_CROPPED: 'Collage Cropped',
  COLLAGE_LAYOUT_CHANGED: 'Collage Layout Changed',
  COLLAGE_LAYOUT_DRAWER_TAPPED: 'Collage Layout Drawer Tapped',
  COLLAGE_LAYOUT_DRAWER_LAYOUT_TAPPED: 'Collage Layout Drawer: Layout Tapped',
  COLLAGE_LAYOUT_DRAWER_DONE_TAPPED: 'Collage Layout Drawer: Done Tapped',
  COLLAGE_TEXT_TAPPED: 'Collage Text Tapped',
  COLLAGE_TEXT_STYLE_SELECTED: 'Collage Text Style Selected',
  COLLAGE_TEXT_DRAWER_TAPPED: 'Collage Text Drawer Tapped',
  COLLAGE_TEXT_DRAWER_DONE_TAPPED: 'Collage Text Drawer: Done Tapped',
  CROP_ORIENTATION_FIT: 'Crop: Orientation fit',
  INCOMPLETE_COLLAGE_POPUP_OPENED: 'Incomplete Collage Popup Opened',
  INCOMPLETE_COLLAGE_POPUP_APPROVED: 'Incomplete Collage Popup Approved',
  INCOMPLETE_COLLAGE_POPUP_DISMISSED: 'Incomplete Collage Popup Dismissed',
  INCOMPLETE_COLLAGE_WARNING_CREATED: 'Incomplete Collage - Warning Created',
  INCOMPLETE_COLLAGE_WARNING_DISPLAYED:
    'Incomplete Collage - Warning Displayed',
  INCOMPLETE_COLLAGE_WARNING_TAPPED: 'Incomplete Collage - Warning Tapped',
  AI_TILE_GENERATING_WARNING_CREATED: 'AI Tile Generating - Warning Created',
  AI_TILE_GENERATING_WARNING_DISPLAYED:
    'AI Tile Generating - Warning Displayed',
  AI_TILE_GENERATING_WARNING_TAPPED: 'AI Tile Generating - Warning Tapped',
  FEATURE_FORCED: 'Feature Forced',
  COLLAGE_PHOTO_TAPPED: 'Collage Photo Tapped',
  DESIGNER_PAGE_VIEW: 'Designer Page View',
  DISCOVERY_PAGE_VIEW: 'Discovery Page View',
  EMPTY_TILE_TAPPED: 'Empty Tile Tapped',
  EMAIL_SUBSCRIPTION_STATUS_CHANGED: 'Email Subscription Status Changed',
  STICKY_EXPERIMENTS_APPLIED: 'Sticky Experiments Applied',
  GOOGLE_PHOTOS_AUTHORIZE_TAPPED: 'Google Photos: Authorize Tapped',
  GOOGLE_PHOTOS_AUTHENTICATED: 'Google Photos: Authenticated',
  GOOGLE_PHOTOS_OPEN_TAPPED: 'Google Photos: Open Tapped',
  GOOGLE_PHOTOS_LOGOUT_TAPPED: 'Google Photos: Logout Tapped',
  GOOGLE_PHOTOS_ERROR: 'Google Photos: Error',
  IOS_UPLOAD_COMMUNICATION_DISPLAYED: 'IOS Upload Communication Displayed',
  LOGIN_EMAIL_ENTERED: 'EmbeddedLogin - Email Entered',
  LOGIN_EMAIL_CODE_ENTERED: 'EmbeddedLogin - Email Code Entered',
  LOGIN_RESEND_CODE_CLICKED: 'EmbeddedLogin - Resend Code Clicked',
  LOGIN_ERROR: 'Login Error',
  LOGIN_OR_SIGN_UP_DIALOG_OPENED: 'Login or Sign Up Dialog Opened',
  LOGIN_SOCIAL_LOGIN_GOOGLE:
    'EmbeddedLogin - Social EmbeddedLogin Selected - Google',
  LOGIN_SOCIAL_LOGIN_FACEBOOK:
    'EmbeddedLogin - Social EmbeddedLogin Selected - Facebook',
  LOGIN_SOCIAL_LOGIN_APPLE:
    'EmbeddedLogin - Social EmbeddedLogin Selected - Apple',
  LOW_RESOLUTION_REVIEW_AND_REPLACE_TAPPED:
    'Low Resolution - Review and Replace Tapped',
  LOW_RESOLUTION_WARNING_CREATED: 'Low Resolution - Warning Created',
  LOW_RESOLUTION_WARNING_DISPLAYED: 'Low Resolution - Warning Displayed',
  LOW_RESOLUTION_WARNING_TAPPED: 'Low Resolution - Warning Tapped',
  FACES_CROP_WARNING_REVIEW_TAPPED: 'Faces Cropped - Review Tapped',
  FACES_CROP_WARNING_CREATED: 'Faces Cropped - Warning Created',
  FACES_CROP_WARNING_DISPLAYED: 'Faces Cropped - Warning Displayed',
  FACES_CROP_WARNING_TAPPED: 'Faces Cropped - Warning Tapped',
  ART_ORIENTATION_WARNING_REVIEW_TAPPED: 'Art Orientation - Review Tapped',
  ART_ORIENTATION_WARNING_CREATED: 'Art Orientation - Warning Created',
  ART_ORIENTATION_WARNING_DISPLAYED: 'Art Orientation - Warning Displayed',
  ART_ORIENTATION_WARNING_TAPPED: 'Art Orientation - Warning Tapped',
  TILE_WARNING_DISMISSED: 'Tile Warning Dismissed',
  CANADA_TARIFF_NOTICE_DISMISSED: 'Canada Tariff Notice Dismissed',
  MEASUREMENTS_TAPPED: 'Measurements Tapped',
  MENU_ITEM_TAPPED: 'Menu Item Tapped',
  MENU_OPENED: 'Menu Opened',
  NAME_CAPTURED: 'Name Captured',
  OS_PICKER_OPENED: 'OS Picker Opened',
  ORDER_COUNTRY_RESTRICTION_POPUP_SHOWN:
    'Order Country Restriction Popup Shown',
  ORDER_COUNTRY_RESTRICTION_POPUP_CLOSED:
    'Order Country Restriction Popup Closed',
  PAGE_FULLY_SCROLLED: 'Page Fully Scrolled',
  PHOTOS_UPLOADED: 'Photos Uploaded',
  PHOTOS_UPLOADED_TO_COLLAGE: 'Photos Uploaded To Collage',
  PHOTO_PICKED: 'Photo Picked',
  PHOTO_REMOVED: 'Photo Removed',
  PHOTO_TAPPED: 'Photo Tapped',
  PHOTO_REPLACED: 'Photo Replaced',
  PICK_PHOTOS_TAPPED: 'Pick Photos Tapped',
  PRODUCT_PAGE_CARD_VIEWED: 'Product Page: Card Viewed',
  PRODUCT_PAGE_MINIMIZED_TAPPED: 'Product Page: Minimize Tapped',
  PRODUCT_PAGE_MORE_INFO_TAPPED: 'Product Page: More Info Tapped',
  TOAST_ACTION_TAPPED: 'Toast Action Tapped',
  TOAST_DISPLAYED: 'Toast Displayed',
  TOAST_DISMISSED: 'Toast Dismissed',
  CREATE_COLLAGE_TAPPED: 'Create Collage Tapped',
  PRODUCT_CARD_TAPPED: 'Product Card Tapped',
  PRODUCT_CARD_VIEWED: 'Product Card Viewed',
  PROMO_CODE_ADDED: 'Promo Code Added',
  PROMO_CODE_ALREADY_REGISTERED: 'Promo Code Already Registered',
  PROMO_CODE_CHANGED: 'Promo Code Changed',
  PROMO_CODE_SELECTED: 'Promo Code Selected',
  PURCHASE_ART_COLLECTION: 'Purchase Art Collection',
  PURCHASE_PHOTO_BOOK: 'Purchase Photo Book',
  BACK_TO_DISCOVERY_TAPPED: 'Back to Discovery Tapped',
  PRODUCT_ORDERED: 'Product Ordered',
  PRODUCT_SHOT_SWIPED: 'Product Shot Swiped',
  REDIRECTED_TO_MIXTILES_2_0: 'Redirected to Mixtiles 2.0',
  REFRESHER_KIT_REQUEST_SUBMITTED: 'Refresher Kit: Request Submitted',
  REFRESHER_KIT_TILES_SELECTED: 'Refresher Kit: Tiles Selected',
  REMOVED_OLD_PHOTO: 'Removed Old Photo',
  REPLACE_PHOTO_DONE_TAPPED: 'Replace Photo: Done Tapped',
  REPLACE_PHOTO_IMAGE_TAPPED: 'Replace Photo: Image Tapped',
  REPLACE_PHOTO_TAPPED: 'Replace Photo Tapped',
  COLLAGE_PHOTO_REPLACED: 'Collage Photo Replaced',
  REPLACE_PHOTO_UPLOAD_TAPPED: 'Replace Photo: Upload Tapped',
  SIGN_OUT_TAPPED: 'Sign Out Tapped',
  SIZES_DRAWER_DONE_TAPPED: 'Sizes Drawer: Done Tapped',
  SIZES_DRAWER_SIZE_TAPPED: 'Sizes Drawer: Size Tapped',
  SIZES_DRAWER_TAPPED: 'Sizes Drawer Tapped',
  SKIP_TAPPED: 'Skip Tapped',
  STATIC_PHOTO_TAPPED: 'Static Photo Tapped',
  TALK_TO_US_TAPPED: 'Talk To Us Tapped',
  MATERIAL_DRAWER_TAPPED: 'Material Drawer Tapped',
  MATERIAL_DRAWER_DONE_TAPPED: 'Material Drawer: Done Tapped',
  MATERIAL_DRAWER_MATERIAL_TAPPED: 'Material Drawer: Material Tapped',
  FRAME_DRAWER_TAPPED: 'Frame Drawer Tapped',
  FRAME_DRAWER_DONE_TAPPED: 'Frame Drawer: Done Tapped',
  FRAME_DRAWER_FRAME_TAPPED: 'Frame Drawer: Frame Tapped',
  FILTER_DRAWER_TAPPED: 'Filter Drawer Tapped',
  FILTER_DRAWER_DONE_TAPPED: 'Filter Drawer: Done Tapped',
  FILTER_DRAWER_FILTER_TAPPED: 'Filter Drawer: Filter Tapped',
  MAT_DRAWER_TAPPED: 'Mat Drawer Tapped',
  MAT_DRAWER_DONE_TAPPED: 'Mat Drawer: Done Tapped',
  MAT_DRAWER_MAT_TAPPED: 'Mat Drawer: Mat Tapped',
  MAT_DRAWER_MAT_COLOR_TAPPED: 'Mat Drawer: Mat Color Tapped',
  OUT_OF_STOCK_SUPPRESSED: 'Out Of Stock Suppressed',
  POSITION_SWAPPED: 'Position Swapped',
  SWAP_POSITION_PHOTO_SELECTED: 'Swap Photo Position: Photo Selected',
  SWAP_POSITION_TAPPED: 'Swap Photo Position Tapped',
  PHOTO_SMART_CROPPED: 'Photo Smart Cropped',
  PHOTO_SMART_CROP_TIMED_OUT: 'Photo Smart Crop Timed Out',
  TILE_CROPPED: 'Tile Cropped',
  TILE_REMOVED: 'Tile Removed',
  TILE_DUPLICATED: 'Tile Duplicated',
  TILE_SIZE_DRAWER_DONE_TAPPED: 'Tile Size Drawer: Done Tapped',
  TILE_SIZE_DRAWER_SIZE_TAPPED: 'Tile Size Drawer: Size Tapped',
  TILE_SIZE_DRAWER_TAPPED: 'Tile Size Drawer Tapped',
  TILE_FRAME_DRAWER_TAPPED: 'Tile Frame Drawer Tapped',
  TILE_FRAME_DRAWER_DONE_TAPPED: 'Tile Frame Drawer: Done Tapped',
  TILE_FRAME_DRAWER_FRAME_TAPPED: 'Tile Frame Drawer: Frame Tapped',
  TILE_FILTER_DRAWER_TAPPED: 'Tile Filter Drawer Tapped',
  TILE_FILTER_DRAWER_DONE_TAPPED: 'Tile Filter Drawer: Done Tapped',
  TILE_FILTER_DRAWER_FILTER_TAPPED: 'Tile Filter Drawer: Filter Tapped',
  TILE_MATERIAL_DRAWER_TAPPED: 'Tile Material Drawer Tapped',
  TILE_MATERIAL_DRAWER_DONE_TAPPED: 'Tile Material Drawer: Done Tapped',
  TILE_MATERIAL_DRAWER_MATERIAL_TAPPED: 'Tile Material Drawer: Material Tapped',
  TILE_MAT_DRAWER_TAPPED: 'Tile Mat Drawer Tapped',
  TILE_MAT_DRAWER_DONE_TAPPED: 'Tile Mat Drawer: Done Tapped',
  TILE_MAT_DRAWER_MAT_COLOR_TAPPED: 'Tile Mat Drawer: Mat Color Tapped',
  TILE_MAT_DRAWER_MAT_TAPPED: 'Tile Mat Drawer: Mat Tapped',
  TILES_ORDERED: 'Tiles Ordered',
  ARTWORK_ORDERED: 'Artwork Ordered',
  TRY_NEW_PRODUCT_TAPPED: 'Try New Product Tapped',
  EXPERIMENT_ACTIVATED: 'Experiment Activated',
  UNDO_TAPPED: 'Undo Tapped',
  WALL_PANNED: 'Wall Panned',
  WALL_ZOOMED: 'Wall Zoomed',
  WALL_DESIGNER_HEIGHT_LIMIT_EXCEEDED: 'Wall Designer: Height Limit Exceeded',
  ZOOM_BUTTON_CLICKED: 'Zoom Button Clicked',
  RESTORED_PHOTO_BANK: 'Restored photo bank',
  PHOTO_BANK_CAP_REACHED: 'Photo Bank: Cap Reached',
  PHOTO_BANK_STORAGE_FULL: 'Photo Bank: Storage Full',
  PHOTOBOOK_UPSELL_CLICKED: 'Photobook Upsell Clicked',
  PHOTOBOOK_UPSELL_DISPLAYED: 'Photobook Upsell Displayed',
  PHOTO_IN_GRID_SELECTED: 'Photo In Grid Selected',
  PHOTO_IN_GRID_DESELECTED: 'Photo In Grid Deselected',
  PHOTOS_RENDERED: 'Photos Rendered',
  PRICING_GENERAL_ERROR: 'Pricing General Error',
  FAILED_UPLOADS_DISPLAYED: 'Failed Uploads Displayed',
  DISCOVERY_CATEGORY_TAPPED: 'Discovery: Category Tapped',
  HOME_PAGE_BOOKS_BANNER_TAPPED: 'Homepage: Books Banner Tapped',
  HOME_PAGE_CROSS_SELL_TAPPED: 'Homepage: Cross-Sell Tapped',
  IMAGE_RENDER_FAILED: 'Image Render Failed',
  WEBGL_NOT_SUPPORTED: 'WebGL Not Supported',
  PHOTO_UPLOAD_FAILED: 'Photo Upload Failed',
  LOCAL_PHOTO_UPLOAD_FAILED: 'Local Photo Upload Failed',
  PHOTO_FACE_DETECTION_ONLINE_FAILED: 'Photo Face Detection Online Failed',
  PHOTO_FACE_DETECTION_ONLINE_FINISHED: 'Photo Face Detection Online Finished',
  PHOTO_PET_DETECTION_FINISHED: 'Photo Pet Detection Finished',
  HOMEPAGE_MAIN_CTA_TAPPED: 'Homepage Main CTA Tapped',
  HOMEPAGE_RENDERED: 'Homepage Rendered',
  HOMEPAGE_CTA_TAPPED: 'Homepage CTA Tapped',
  ONBOARDING_RENDERED: 'Onboarding Rendered',
  ADDRESS_ELEMENT_LOADED: 'Address Element Loaded',
  ADDRESS_ELEMENT_LOAD_ERROR: 'Address Element Load Error',
  PAYMENT_ELEMENT_LOADED: 'Payment Element Loaded',
  PAYMENT_ELEMENT_LOAD_ERROR: 'Payment Element Load Error',
  PAYMENT_METHOD_SUBMITTED_SUCCESSFULLY:
    'Payment Method Submitted Successfully',
  EXPRESS_CHECKOUT_PAY_TAPPED: 'Express Checkout: Pay Tapped',
  EXPRESS_CHECKOUT_RECEIVED_PAYMENT_METHOD:
    'Express Checkout: Received Payment Method',
  EXPRESS_CHECKOUT_PAYMENT_ABORTED: 'Express Checkout: Payment Aborted',
  EXPRESS_CHECKOUT_PAYMENT_ERROR: 'Express Checkout: Payment Error',
  WALLET_AVAILABLE: 'Wallet Available',
  WALLET_LOAD_ERROR: 'Wallet Load Error',
  PAYPAL_ERROR: 'PayPal Error',
  PAYPAL_BUTTON_TAPPED: 'PayPal Button Tapped',
  PAYPAL_ORDER_CREATED: 'PayPal Order Created',
  PAYPAL_ORDER_APPROVED: 'PayPal Order Approved',
  PAYPAL_ORDER_CANCELLED: 'PayPal Order Cancelled',
  PAYPAL_BUTTON_RENDERED: 'PayPal Button Rendered',
  PAYPAL_NOT_RENDERED: 'Paypal Not Rendered',
  MISSING_EMAIL_SHOWN: 'Missing Email Shown',
  SAME_ADDRESS_CHECKBOX_TAPPED: 'Same Address Checkbox Tapped',
  ENTRYPOINT_RENDERED: 'Entrypoint Rendered',
  SMS_CONSENT_CHECKBOX_TAPPED: 'Sms Consent Checkbox Tapped',
  EMAIL_CONSENT_CHECKBOX_TAPPED: 'Email Consent Checkbox Tapped',
  ATTRIBUTION_SURVEY_EXPANDED_CHANNEL_TAPPED:
    'Attribution Survey Expanded Channel Tapped',
  PHOTO_UPLOADED: 'Photo Uploaded',
  EMPTY_PHOTO_UPLOADED: 'Empty Photo Uploaded',
  EFFECT_FAILED: 'Effect Failed',
  LOGO_TAPPED: 'Logo Tapped',
  EXCEEDING_COLLAGE_PHOTOS_VIEW: 'Exceeding Collage Photos View',
  EXCEEDING_COLLAGE_PHOTOS_VIEW_DONE_TAPPED:
    'Exceeding Collage Photos View: Done Tapped',
  NO_CONSENT_REQUIRED: 'No Consent Required',
  SHOW_CONSENT_FIRST_LAYER: 'Show Consent First Layer',
  POPUP_CTA_TAPPED: 'Popup CTA Tapped',
  POPUP_DISMISSED: 'Popup Dismissed',
  POPUP_DISPLAYED: 'Popup Displayed',
  BAD_CROP_DETECTION_COMPLETED: 'Bad Crop Detection Completed',
  BAD_CROP_DETECTION_SUMMARY: 'Bad Crop Detection Summary',
  DELIVERY_PROMISE_UPDATED: 'Delivery Promise Updated',
  TILE_DESIGNER_ZOOMED: 'Tile Designer Zoomed',
  STRIP_3D_RENDERED: 'Strip 3D Rendered',
  SUSPECTED_CRASH: 'Suspected Crash',
  HOMEPAGE_VIDEO_FIRST_PLAYED: 'Video/Story First Played',
  HOMEPAGE_VIDEO_COMPLETED: 'Video/Story Completed',
  HOMEPAGE_STORY_MUTED: 'Story Muted',
  HOMEPAGE_STORY_UNMUTED: 'Story Unmuted',
  HOMEPAGE_FAQ_TAPPED: 'FAQ - Question Tapped',
  HOMEPAGE_FOLLOW_US_TAPPED: 'Follow Us Tapped',
  HOMEPAGE_COVERED_VIEWED: "We've Got You Covered Viewed",
  HOMEPAGE_FAQ_VIEWED: 'Frequently Asked Questions Viewed',
  UPLOAD_PROGRESS_BAR_COMPLETED: 'Upload Progress Bar Completed',
  PHOTO_UPLOAD_PROGRESS_COMPLETED: 'Photo Upload Progress Completed',
  SWITCH_TO_SAFARI_POPUP_SHOWN: 'Switch to Safari Popup Shown',
  SWITCH_TO_SAFARI_POPUP_CONFIRMED: 'Switch to Safari Popup Confirmed',
  SWITCH_TO_SAFARI_POPUP_DISMISSED: 'Switch to Safari Popup Dismissed',
  SWITCH_BROWSER_DATA_SYNCED: 'Switch Browser Data Synced',
  PAGE_SCROLL_HORIZONTALLY: 'Page Scroll Horizontally',
  LOW_RES_MODELS_LOADED: 'Low Res Models Loaded',
  JOB_APPLICATION_CLICKED: 'Job Application Clicked',
  JOB_APPLICATION_SUBMITTED: 'Job Application Submitted',
  ZOOMED_WITH_PINCH: 'Zoomed with Pinch',
  APP_CLOSED: 'App Closed',
  ZOOM_CHANGED_WHILE_PANNING: 'Zoom Changed While Panning',
  APP_REFRESHED_AFTER_LONG_IDLE: 'App refreshed after long idle',
  SERVICE_WORKER_INSTALLED: 'Service Worker Installed',
  FILES_DROPPED: 'Files Dropped',
  REFERRAL_SENT: 'Referral Sent',
  REFERRAL_REDEEMED: 'Referral Redeemed',
  SHIPPING_OPTION_CHANGED: 'Shipping Option Changed',
  CHANGE_STORE_PICKUP_TAPPED: 'Change Store Pickup Tapped',
  STORE_PICKUP_ADDRESS_CHANGED: 'Store Pickup Address Changed',
  DARK_MODE_DETECTED: 'Dark Mode Detected',
  VERTICAL_SCROLL_TO_HORIZONTAL: 'Vertical Scroll To Horizontal',
  PRODUCT_SELECTION_PRODUCT_TAPPED: 'Product Selection: Product Tapped',
  SET_USER_EMAIL_TRIGGERED: 'Set User Email Triggered',
  GALLERY_WALLS_FRAME_DRAWER_TAPPED: 'Gallery Frame Drawer Tapped',
  GALLERY_WALLS_PHOTOS_DRAWER_TAPPED: 'Gallery Photos Drawer Tapped',
  GALLERY_WALLS_BORDER_DRAWER_TAPPED: 'Gallery Border Drawer Tapped',
  GALLERY_WALLS_EFFECT_DRAWER_TAPPED: 'Gallery Effect Drawer Tapped',
  GALLERY_WALLS_PHOTOS_DRAWER_DONE_TAPPED: 'Gallery Photos Drawer Done Tapped',
  POST_PURCHASE_UPSELL_DISPLAYED: 'Post Purchase Upsell Displayed',
  POST_PURCHASE_UPSELL_DISMISSED: 'Post Purchase Upsell Dismissed',
  POST_PURCHASE_UPSELL_CTA_TAPPED: 'Post Purchase Upsell CTA Tapped',
  SHARE_REFERRAL_LINK_TAPPED: 'Share Referral Link Tapped',
  CENTERPIECE_ADDED: 'Centerpiece Added',
  CENTERPIECE_SELECTION_CHANGED: 'Centerpiece Selection Changed',
  COLLAGE_ADDED: 'Collage Added',
  PRODUCT_PAGE_VISIT: 'Product Page: Visit',
  PRODUCT_PAGE_FRAME_CHANGED: 'Product Page: Frame Changed',
  PRODUCT_PAGE_SIZE_CHANGED: 'Product Page: Size Changed',
  PRODUCT_PAGE_LOAD_MORE_REVIEWS_TAPPED:
    'Product Page: Load More Reviews Tapped',
  PRODUCT_PAGE_FAQ_TAPPED: 'Product Page: FAQ tapped',
  PRODUCT_PAGE_ADD_ITEM_TAPPED: 'Product Page: Add Item Tapped',
  PRODUCT_PAGE_BROWSE_ART_TAPPED: 'Product Page: Browse Art Tapped',
  PRODUCT_PAGE_VIDEO_SWIPE_TAPPED: 'Product Page: Video Swipe Tapped',
  PRODUCT_PAGE_PHOTO_SHOT_SWIPED: 'Product Page: Product Shot Swiped',
  ORDER_MANAGEMENT_CANCEL_ORDER_TAPPED: 'Order Management: Cancel Order Tapped',
  ORDER_MANAGEMENT_CANCEL_POPUP_DISPLAYED:
    'Order Management: Cancel Order Popup Displayed',
  ORDER_MANAGEMENT_CANCEL_ORDER_ATTEMPT_DISABLED:
    'Order Management: Cancel Order Attempt – Disabled',
  ORDER_MANAGEMENT_CANCEL_ORDER_DISMISSED:
    'Order Management: Cancel Order Dismissed',
  ORDER_MANAGEMENT_CANCEL_ORDER_CONFIRMED:
    'Order Management: Order Cancellation Confirmed',
  ORDER_MANAGEMENT_CANCEL_ORDER_COMPLETED:
    'Order Management: Cancel Order Completed',
  ORDER_MANAGEMENT_CANCEL_ORDER_FAILED: 'Order Management: Cancel Order Failed',
  ORDER_MANAGEMENT_CANCEL_AND_EDIT_ORDER_CONFIRMED:
    'Order Management: Cancel and Edit Order Confirmed',
  ORDER_MANAGEMENT_EDIT_ORDER_POPUP_DISPLAYED:
    'Order Management: Edit Order Tapped',
  ORDER_MANAGEMENT_EDIT_ORDER_DISMISSED:
    'Order Management: Edit Order Dismissed',
  EMAIL_CAPTURED_OVERRIDDEN: 'Email Captured Overridden',
  AI_TEMPLATE_VIEWED: 'AI Template Viewed',
  AI_TEMPLATES_FEED_REACHED_END: 'AI Templates Feed Reached End',
  AI_TEMPLATE_CREATE_TAPPED: 'AI Template Create Tapped',
  AI_TEMPLATE_ADD_PHOTOS_TAPPED: 'AI Template Add Photos Tapped',
  AI_TEMPLATE_PHOTO_PICKED: 'AI Templates Photo Picked',
  AI_TEMPLATE_PHOTO_REMOVED: 'AI Templates Photo Removed',
  AI_TEMPLATE_ARTWORK_REQUESTED: 'AI Templates Artwork Requested',
  AI_TEMPLATE_ARTWORK_GENERATION_STARTED: 'AI Artwork Generation Started',
  AI_TEMPLATE_ARTWORK_GENERATION_COMPLETED: 'AI Artwork Generation Completed',
  AI_TEMPLATE_ARTWORK_GENERATION_FAILED: 'AI Artwork Generation Failed',
  AI_TEMPLATE_FACE_SELECTED: 'AI Template Face Selected',
  AI_TEMPLATE_FACE_UNSELECTED: 'AI Template Face Unselected',
  AI_TEMPLATE_FACE_PROCESSING_STARTED: 'AI Template Face Processing Started',
  AI_TEMPLATE_FACE_PROCESSING_COMPLETED:
    'AI Template Face Processing Completed',
  AI_TEMPLATE_FACE_PROCESSING_FAILED: 'AI Template Face Processing Failed',
  AI_ARTWORK_ADDED: 'AI Artwork Added',
  AI_ARTWORK_VIEWED: 'AI Artwork Viewed',
  AI_ARTWORK_ORDERED: 'AI Artwork Ordered',
  AI_GENERATION_CANCELED: 'AI Generation Canceled',
  AI_GENERATION_BACK_TAPPED: 'AI Generation Back Tapped',
  AI_TEMPLATE_VARIANT_TAPPED: 'AI Template Variant Tapped',
  PET_VARIATION_GENERATION_STARTED: 'Pet Variation Generation Started',
  PET_VARIATION_GENERATION_GENERATED: 'Pet Variation Generation Generated',
  PET_VARIATION_GENERATION_FAILED: 'Pet Variation Generation Failed',
  PET_VARIATION_TILE_AUTO_REMOVED: 'Pet Variation Tile Auto-Removed',
  PET_VARIATION_SHEET_OPENED: 'Pet Variation Sheet Opened',
  PET_VARIATION_SHEET_DISMISSED: 'Pet Variation Sheet Dismissed',
  PET_VARIATION_CREATE_TAPPED: 'Pet Variation Create Tapped',
  PET_VARIATION_CHANGE_PHOTO_TAPPED: 'Pet Variation Change Photo Tapped',
  USER_LOGGED_IN_WITH_INITIAL_BRAZE_ID: 'User Logged In With Initial Braze ID',
  WEB_EMAIL_CAPTURED: 'Web Email Captured',
  PHONE_NUMBER_CAPTURED: 'Phone Number Captured',
  DOWNLOAD_APP_CTA_TAPPED: 'Download App CTA Tapped',
  UNSAVED_UPLOADS_WARNING_DISPLAYED: 'Unsaved Uploads Warning Displayed',
}

// Should be imported only by analytics.js to prevent importing multiple modules
export const _SCREENS = {
  BLOG: 'Blog',
  BLOG_TAG: 'Blog Tag',
  BLOG_ARTICLE: 'Blog Article',
  BUSINESS: 'Business',
  DISCOVERY: 'Discovery',
  TILE_DESIGNER: 'Tile Designer',
  WALL_DESIGNER: 'Wall Designer',
  VOLUME_DISCOUNT: 'Volume Discount',
  GIFT_CARD: 'Gift Card',
  REFERRAL: 'Referral',
  REFRESHER_KIT_REQUEST: 'Refresher Kit Request',
  HOMEPAGE: 'Pitch',
  HOMEPAGE_INDEX: 'Index',
  ORDER_MANAGEMENT: 'Order Management',
  CROP_REVIEW_INTRO: 'Crop Review Intro',
  CROP_REVIEW: 'Crop Review',
  PHOTO_BOOKS_HOME_PAGE: 'Photo Books Homepage',
  PHOTO_BOOKS_DESIGNER: 'Photo Books Designer',
  PHOTO_BOOKS_PRODUCT_PAGE: 'Photo Books Product Page',
  ART_PRODUCT_PAGE: 'Art Product Page',
  PREFERENCES_SAVED: 'Email Preferences Change Confirmation',
  POST_PURCHASE_SUCCESS: 'Post Purchase Success',
  JOB_POSITION: 'Job Position',
  ART_COLLECTION_HOME_PAGE: 'Art Collection Homepage',
  ART_COLLECTION_CATEGORY_PAGE: 'Art Collection Category Page',
  PRODUCT_SELECTION_PAGE: 'Product Selection Page',
  PRODUCT_PAGE_V2: 'Product Page V2',
  POST_PURCHASE_UPSELL: 'Post Purchase Upsell',
  POST_PURCHASE_UPSELL_SIGN_CUSTOMIZATION:
    'Post Purchase Upsell Sign Customization',
  AI_TEMPLATES_FEED: 'AI Templates Feed',
  GOOGLE_PHOTOS_AUTHORIZE: 'Google Photos: Authorize',
  GOOGLE_PHOTOS_OPEN: 'Google Photos: Open',
  GIFT_CARD_VALUE: 'Value Gift Card Purchase Page',
  GIFT_CARD_BUNDLE: 'Quantity Gift Card Purchase Page',
  DOWNLOAD_APP_PAGE: 'Download App Page',
  CART_DRAWER: 'Cart Drawer',
} as const
